// SPDX-License-Identifier: AGPL-3.0-or-later

import Theme from '@app/features/theme/state/Theme';
import type {IconWeight} from '@app/features/ui/icons/Icons';
import {ThemeTypes} from '@fluxer/constants/src/UserConstants';

/** KONVO: true while either glass theme (smoked or light) is the effective theme. Observable. */
export function isGlassThemeActive(): boolean {
	return Theme.effectiveTheme === ThemeTypes.GLASS || Theme.effectiveTheme === ThemeTypes.GLASS_LIGHT;
}

/** KONVO: the glass theme uses outline icons on the rail; other themes keep the filled set. */
export function getRailIconWeight(): IconWeight {
	// KONVO: Tabler rail icons are strokes on every theme; selection is shown by the tile, not by a solid glyph.
	return isGlassThemeActive() ? 'regular' : 'bold';
}
